import { ComponentProps } from "react";

interface ThreeDotsIconProps extends ComponentProps<"svg"> {
  color?: string;
}

export default function ThreeDotsIcon(props: ThreeDotsIconProps) {
  const { color = "currentColor", ...rest } = props;

  return (
    <svg width="11" height="3" viewBox="0 0 11 3" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <ellipse cx="1.1" cy="1.79094" rx="1.1" ry="1.10344" fill={color} />
      <ellipse cx="5.49844" cy="1.79094" rx="1.1" ry="1.10344" fill={color} />
      <ellipse cx="9.90078" cy="1.79094" rx="1.1" ry="1.10344" fill={color} />
    </svg>
  );
}
